import {DeserializableModel} from '../deserializable.model';

export interface Login {
	success: boolean;
	error: string;
	status: string;
	username: string;
	token: string;
	exoid: number;
	message: string;
}

export class UserModel implements DeserializableModel {
	username: string;
	token: string;
	exoid: number;
	location: number;
	appUse: string;

	constructor(username?, token?, exoid?, location?, appUse?) {
		this.username = username;
		this.token = token;
		this.location = location;
		this.appUse = appUse;
		this.exoid = exoid;
	}

	deserialize(input: any): this {
		Object.assign(this, input);
		return this;
	}

	serialize(): string {
		return JSON.stringify(this);
	}
}
